import type { ResolveFn } from '../types.js';

export const resolveCome: ResolveFn = (b, roll) => {
  if (b.number === undefined) {
    if (roll.total === 7 || roll.total === 11) {
      return { betId: b.id, outcome: 'win', payout: b.amount };
    }
    if (roll.total === 2 || roll.total === 3 || roll.total === 12) {
      return { betId: b.id, outcome: 'lose', payout: 0 };
    }
    return { betId: b.id, outcome: 'continue', payout: 0 };
  }
  if (roll.total === b.number) {
    return { betId: b.id, outcome: 'win', payout: b.amount };
  }
  if (roll.total === 7) {
    return { betId: b.id, outcome: 'lose', payout: 0 };
  }
  return { betId: b.id, outcome: 'continue', payout: 0 };
};

export const resolveDontCome: ResolveFn = (b, roll, _state, rules) => {
  if (b.number === undefined) {
    if (roll.total === 7 || roll.total === 11) {
      return { betId: b.id, outcome: 'lose', payout: 0 };
    }
    if (roll.total === rules.dontPassPushOn) {
      return { betId: b.id, outcome: 'push', payout: 0 };
    }
    if (roll.total === 2 || roll.total === 3 || roll.total === 12) {
      return { betId: b.id, outcome: 'win', payout: b.amount };
    }
    return { betId: b.id, outcome: 'continue', payout: 0 };
  }
  if (roll.total === b.number) {
    return { betId: b.id, outcome: 'lose', payout: 0 };
  }
  if (roll.total === 7) {
    return { betId: b.id, outcome: 'win', payout: b.amount };
  }
  return { betId: b.id, outcome: 'continue', payout: 0 };
};
